import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function Contact() {
    const { t } = useTranslation();
    UseScrollAnimation();
    return (
        <>
            <section className="landingPages">
                <div className="container h-[70vh] flex flex-col justify-center gap-[10px]">
                    <div className="btmAni2000 text-[40px] font-bold text-white  capitalize">{t("Contact us")}</div>
                    <div className="btmAni25002 flex items-center gap-[5px] text-white">
                        <Link className="text-white" to={"/"}>{t("Home")}</Link>
                        -
                        <div className="text-[#016E82]">{t("Contact us")}</div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container f-col flex justify-center items-center gap-[20px]">
                    <div className="btmAni20002 w-100 bg-[#282828] rounded-[4px] w-1/4 p-5 flex flex-col gap-5 h-[190px] justify-center">
                        <div className="w-[32px] h-[32px] rounded-full bg-[#BEAD82] flex items-center justify-center">
                            <img className="w-[22px] h-[22px]" src={require("../../assets/icons/location-contact.svg").default} alt="" />
                        </div>
                        <div className="text-white">
                            <div className="font-bold">{t("Location")}</div>
                            <Link to={""}>Aqaba,Jordan</Link>
                        </div>
                    </div>
                    <div className="btmAni3000 w-100 bg-[#282828] rounded-[4px] w-1/4 p-5 flex flex-col gap-5 h-[190px] justify-center">
                        <div className="w-[32px] h-[32px] rounded-full bg-[#BEAD82] flex items-center justify-center">
                            <img className="w-[22px] h-[22px]" src={require("../../assets/icons/email-contact.svg").default} alt="" />
                        </div>
                        <div className="text-white">
                            <div className="font-bold">{t("Email Address")}</div>
                            <Link to={"mailto:info@aqaba-seasons.com"}>info@aqaba-seasons.com</Link>
                        </div>
                    </div>
                    <div className="btmAni2500 w-100 bg-[#282828] rounded-[4px] w-1/4 p-5 flex flex-col gap-5 h-[190px] justify-center">
                        <div className="w-[32px] h-[32px] rounded-full bg-[#BEAD82] flex items-center justify-center">
                            <img className="w-[22px] h-[22px]" src={require("../../assets/icons/phone-contact.svg").default} alt="" />
                        </div>
                        <div className="text-white">
                            <div className="font-bold">{t("Phone Number")}</div>
                            <Link className="dr-ltr" to={"tel:+962 797386309"}>+962 79 738 6309</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container relative bg-[#282828] p-[20px] rounded-[8px] flex flex-col gap-[25px] items-center item-norm">
                    <img className="d-none w-[12%] h-full absolute right-0 top-[-160px]" src={require("../../assets/icons/contact-form-image.svg").default} alt="" />
                    <div className="js-scroll fade-top text-[35px] font-bold text-white capitalize tracking-[2.2px]">{t("Get in touch")}</div>
                    <form action={"https://aqaba-seasons.com/submit_contact_form.php"} method="POST" >
                        <div className="flex flex-col gap-[12px]">
                            <div className="flex flex-col gap-[7px]">
                                <label className="js-scroll fade-top text-white font-bold">{t("Full Name")}</label>
                                <input
                                    className="js-scroll fade-btm w-100 w-[650px] p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-white"
                                    type="text"
                                    placeholder={t("Enter Your Name")}
                                    required
                                    name="fullName"
                                />
                            </div>
                            <div className="flex flex-col gap-[7px]">
                                <label className="js-scroll fade-top text-white font-bold">{t("Email")}</label>
                                <input
                                    className="js-scroll fade-btm w-100 w-[650px] p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-white"
                                    type="email"
                                    placeholder={t("Enter Your Email")}
                                    required
                                    name="email"
                                />
                            </div>
                            <div className="flex flex-col gap-[7px]">
                                <label className="js-scroll fade-top text-white font-bold">{t("Message")}</label>
                                <textarea
                                    className="js-scroll fade-btm w-100 w-[650px] h-[250px] max-h-[300px] p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-white"
                                    placeholder={t("Enter Your Message")}
                                    name="message"
                                >
                                </textarea>
                            </div>
                            <button type="submit" className="js-scroll fade-btm w-fit mx-auto bg-[#016E82] text-white px-[40px] py-[8px] rounded font-bold capitalize">{t("Submit")}</button>
                        </div>
                    </form>

                </div>
            </section>
        </>
    );
}